<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm02_half"></a><a id="page_i"></a>The Heart <span class="underline">of</span> Leadership</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_half.vue?b2b28df8